/**
 * Registers the `profile` namespace bundles with the shared i18next instance.
 * Imported for its side effect by the feature's pages/components so the
 * namespace is available before any Profile screen renders.
 */
import { i18n } from '../../i18n/config';
import enProfile from '../../locales/en-US/profile.json';
import esProfile from '../../locales/es-MX/profile.json';
import frProfile from '../../locales/fr-CA/profile.json';

const NAMESPACE = 'profile';

i18n.addResourceBundle('en-US', NAMESPACE, enProfile, true, false);
i18n.addResourceBundle('es-MX', NAMESPACE, esProfile, true, false);
i18n.addResourceBundle('fr-CA', NAMESPACE, frProfile, true, false);

export const profileNamespace = NAMESPACE;
